import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { SpinnerModule } from '../../components/spinner/spinner.module';
import { CustomColumnsModule } from '../custom-columns/custom-columns.module';
import { CustomModalsModule } from '../custom-modals/custom-modals.module';
import { CustomNavigationModule } from '../custom-navigation/custom-naigation.module';
import { CustomViewsModule } from '../custom-views/custom-views.module';
import { ImportOrderToTripActionComponent } from './components/actions/import-order-to-trip/import-order-to-trip-action.component';
import { ConfigurableTableActionsComponent } from './components/configurable-table-actions/configurable-table-actions.component';
import { ConfigurableTableBarComponent } from './components/configurable-table-bar/configurable-table-bar.component';
import { ConfigurableTableHeaderComponent } from './components/configurable-table-header/configurable-table-header.component';
import { ConfigurableTableTabComponent } from './components/configurable-table-tab/configurable-table-tab.component';
import { ConfigurableTableComponent } from './components/configurable-table/configurable-table.component';
import { TableConfigurationBuilder } from './services/table-configuration.builder';
import { TableDataMapperService } from './services/table-data-mapper.service';
import { TableGlobalEventService } from './services/table-global-event.service';
import { TableNavigationService } from './services/table-navigation.service';
import { TableTemplateService } from './services/table-template.service';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatIconModule,
    CustomColumnsModule,
    CustomViewsModule,
    CustomModalsModule,
    CustomNavigationModule,
    SpinnerModule,
  ],
  declarations: [
    ConfigurableTableComponent,

    ConfigurableTableBarComponent,
    ConfigurableTableHeaderComponent,
    ConfigurableTableActionsComponent,
    ConfigurableTableTabComponent,

    ImportOrderToTripActionComponent,
  ],
  exports: [
    ConfigurableTableTabComponent,
    ConfigurableTableComponent,
  ],
  providers: [
    TableTemplateService,
    TableNavigationService,
    TableDataMapperService,
    TableGlobalEventService,
    TableConfigurationBuilder,
  ],

})
export class CustomTableModule { }
